import { defineStore } from 'pinia';
const useForeverStore = defineStore('app-forever', {
	// 持久化存储，可以根据自己需求配置哈
	state: () => ({
		orderNoListStr: '',
		totalBookingValue: 0,
		bvCurrencyCode: ''
	}),
	actions: {
		setOrderNoListStr(orderNoListStr: string): void {
			this.orderNoListStr = orderNoListStr;
		},
		setTotalBookingCode(totalBookingValue: number): void {
			this.totalBookingValue = totalBookingValue;
		},
		setBvCurrencyCode(bvCurrencyCode: string): void {
			this.bvCurrencyCode = bvCurrencyCode;
		}
	},
	getters: {
		getOrderNoListStr(): string {
			return this.orderNoListStr;
		},
		getTotalBookingCode(): any {
			return this.totalBookingValue;
		},
		getBvCurrencyCode(): string {
			return this.bvCurrencyCode;
		}
	},
	//persist定义要做判断，因为localStorage是客户端参数，所以需要加process.client
	persist: process.client && {
		storage: localStorage,
		paths: ['orderNoListStr', 'totalBookingValue', 'bvCurrencyCode']
	}
});
export const setOrderNoListStrFun = (orderNoListStr: string) => {
	useForeverStore().setOrderNoListStr(orderNoListStr);
};
export const setTotalBookingCodeFun = (totalBookingValue: number) => {
	useForeverStore().setTotalBookingCode(totalBookingValue);
};
export const setBvCurrencyCodeFun = (bvCurrencyCode: string) => {
	useForeverStore().setBvCurrencyCode(bvCurrencyCode);
};
export const getOrderNoListStrFun = () => {
	return useForeverStore().getOrderNoListStr;
};
export const getTotalBookingCodeFun = () => {
	return useForeverStore().getTotalBookingCode;
};
export const getBvCurrencyCodeFun = () => {
	return useForeverStore().getBvCurrencyCode;
};
